import React from 'react';
import UpdateNameAccount from 'pages/counselor/account/UpdateNameAccount';

const ProfileUpdateName = () => {
    return <UpdateNameAccount />;
};

export default ProfileUpdateName;
